<template>
  <div>
    <van-action-sheet v-model="showClientList" :actions="clientList"
                      @select="onSelect" @close="onClose" close-on-click-action
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showClientList: this.show
    }
  },
  watch: {
    show: function(value) {
      this.showClientList = value
    }
  },
  computed: {
    ...mapGetters(['clientList'])
  },
  methods: {
    onSelect(client) {
      window.localStorage.removeItem('balanceData')
      this.$store.dispatch('app/setCurrentClient', client)
    },
    onClose() {
      this.$emit('change', this.showClientList)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/commons/change-company.vue